import PropTypes from "prop-types";
import React from "react";
import injectSheet from "react-jss";

const styles = theme => ({
  tabMenu: {
    color: "#fff",
    display: "flex",
    height: "100%",
    alignItems: "center",
    justifyContent: "center",
    textDecoration: "none",
    cursor: "pointer",
    transition: "background-color .2s linear",
    position: "relative",
    "&:hover": {
      backgroundColor: theme.hoverColor
    },
    "&:hover $dropDownContent": {
      display: "block"
    }
  },
  dropDownContent: {
    display: "none",
    position: "absolute",
    backgroundColor: theme.colours.palette.blue,
    width: "215px",
    boxShadow: "0px 8px 16px 0px rgba(0,0,0,0.2)",
    zIndex: "10",
    top: "100%",
    left: "calc(-50%)"
  },
  dropDownButton: {
    display: "flex",
    height: "100%",
    alignItems: "center"
  }
});

const TabMenu = ({ classes, children, anchorText, className = "" }) => (
  <div className={`${classes.tabMenu} ${className}`}>
    <div className={classes.dropDownButton}>{anchorText}</div>
    <div className={classes.dropDownContent}>{children}</div>
  </div>
);

TabMenu.propTypes = {
  anchorText: PropTypes.string.isRequired,
  children: PropTypes.object,
  classes: PropTypes.object,
  className: PropTypes.string
};

export default injectSheet(styles)(TabMenu);



// WEBPACK FOOTER //
// ./src/components/TopBar/TabMenu.jsx